/**
 * ChatSessionProvider - Context provider that keeps chat state alive across route navigations.
 * Wraps the app so the conversation persists when navigating between pages.
 */
import { createContext, useContext, type ReactNode } from 'react';
import { useChatSessionInternal, type UseChatSessionReturn } from './useChatSession';

const ChatSessionContext = createContext<UseChatSessionReturn | null>(null);

export function ChatSessionProvider({ children }: { children: ReactNode }) {
  const session = useChatSessionInternal();

  return (
    <ChatSessionContext.Provider value={session}>
      {children}
    </ChatSessionContext.Provider>
  );
}

export function useChatSession(): UseChatSessionReturn {
  const context = useContext(ChatSessionContext);
  if (!context) {
    throw new Error('useChatSession must be used within a ChatSessionProvider');
  }
  return context;
}
